import React, { useEffect } from "react";
import { Box, Typography, CircularProgress, Paper } from "@mui/material";
import Logo from "../../assets/images/logo.png";
import { API_URL, backend } from "../../config";
import ContactInfo from "./ContactInfo";

const ManualReview = (props) => {
  useEffect(() => {
    const logout = () => {
      localStorage.removeItem("user");
      window.location = "/";
    };

    const checkManualReviewStatus = async () => {
      try {
        const response = await backend.get(`${API_URL}users/?no_page=1`);

        if (response.status === 200) {
          if (response.data?.length > 0) {
            const userSession = JSON.parse(localStorage.getItem("user"));

            const currentUser = response.data.find(
              (u) => u.username === userSession?.user?.username,
            );

            if (currentUser) {
              if (!currentUser.needs_manual_review) {
                userSession.user.needs_manual_review = false;
                localStorage.setItem("user", JSON.stringify(userSession));
                window.location = "/";
              }
            } else {
              logout();
            }
          } else {
            logout();
          }
        }
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            logout();
          }
        }
      }
    };

    checkManualReviewStatus();
  }, []);

  return (
    <Box
      position="relative"
      width="100%"
      maxWidth={400}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <img
        src={Logo}
        alt="logo"
        height="80"
        style={{ position: "absolute", top: -110, opacity: 0.9 }}
      />
      <Paper
        elevation={3}
        sx={{ p: 4, textAlign: "center", width: "100%", borderRadius: 2 }}
      >
        <>
          <CircularProgress size={48} sx={{ mb: 2 }} />
          <Typography variant="h6" fontWeight="bold" color="success.main">
            Account approval in process
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Your account needs to be approved before you can fully access. You
            will receive an email once you have been approved.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Contact us if you need any assistance or have any questions!
          </Typography>
        </>
      </Paper>
      <ContactInfo />
    </Box>
  );
};

export default ManualReview;
